import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export interface OpPromoStickyBarElement extends HTMLElement {
  variant?: 'landing-page' | 'product-page';
}

const OpPromoStickyBar = createWrapper<OpPromoStickyBarElement>('op-promo-sticky-bar');

export default OpPromoStickyBar;
